import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large",
    attrs: {
      id: "container-payment"
    }
  }, [!_vm.orderValidated ? _c("div", [_c("return", {
    ref: "return",
    attrs: {
      routeName: _vm.returnRoute,
      params: _vm.returnParams,
      label: "Order Summary"
    }
  }), _c("div", {
    staticClass: "container-centered small-2"
  }, [_vm.loggedUserData.userGroup !== "USER" ? _c("div", {
    staticClass: "payment-title"
  }, [_vm._v(" Please, select a payment method below ")]) : _vm._e(), _c("div", {
    attrs: {
      id: "selectPaymentType"
    }
  }, [_vm.loggedUserData.userGroup !== "USER" ? _c(VBtnToggle, {
    staticClass: "paymentType",
    attrs: {
      mandatory: ""
    },
    on: {
      change: _vm.switchCard
    },
    model: {
      value: _vm.payment_method,
      callback: function callback($$v) {
        _vm.payment_method = $$v;
      },
      expression: "payment_method"
    }
  }, [!_vm.isCreditCardsForbidden ? _c(VBtn, {
    staticClass: "payment-button",
    attrs: {
      value: "cc"
    }
  }, [_c("i", {
    staticClass: "fas fa-money-check mr-2"
  }), _vm._v(" Credit card ")]) : _vm._e(), _vm.order.currency === "EUR" && _vm.isHoreca ? _c(VBtn, {
    staticClass: "payment-button",
    attrs: {
      value: "ba"
    }
  }, [_c("i", {
    staticClass: "fas fa-university mr-2"
  }), _vm._v(" SEPA Direct Debit ")]) : _vm._e()], 1) : _vm._e()], 1), _vm.isLoading ? _c(VSkeletonLoader, {
    staticClass: "mt-2",
    attrs: {
      type: "image"
    }
  }) : _c("div", {
    staticClass: "paymentTypeContainer"
  }, [_vm.payment_method == "cc" ? _c("div", [_c("CreditCardForm", {
    ref: "creditCard",
    attrs: {
      savedCards: _vm.list_credit_cards,
      clientSecret: _vm.client_secret,
      wallet: false,
      stripe: _vm.stripe,
      user: _vm.user,
      order: _vm.order
    },
    on: {
      inputChange: function inputChange() {
        _vm.stripeErrorOccured = false;
      }
    },
    model: {
      value: _vm.creditCard,
      callback: function callback($$v) {
        _vm.creditCard = $$v;
      },
      expression: "creditCard"
    }
  })], 1) : _vm._e(), _vm.payment_method === "ach" ? _c("div", [_vm.achErrorOccurred ? _c("div", {
    staticClass: "text-center text-red"
  }, [_vm._v(" Confirmation failed. Attempt again with a different payment method. ")]) : _vm._e(), [_c("p", {
    staticClass: "saved-bank-accounts"
  }, [_vm._v("Saved bank accounts*")]), _c("div", {
    staticClass: "formfield-select"
  }, [_c("div", {
    staticClass: "formfield-select--container mb-2"
  }, [_c("select", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.usBankAccount,
      expression: "usBankAccount"
    }],
    on: {
      change: [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.usBankAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.switchCard]
    }
  }, [_c("option", {
    domProps: {
      value: 0
    }
  }, [_vm._v(" " + _vm._s(!_vm.list_us_bank_accounts.length ? "No bank accounts" : "Select a bank account") + " ")]), _vm._l(_vm.list_us_bank_accounts, function (ba) {
    return _c("option", {
      key: ba.payment_method_id,
      domProps: {
        value: ba
      }
    }, [_vm._v(" " + _vm._s(ba.country) + "XX" + _vm._s(ba.bank_name) + "XXXXXX" + _vm._s(ba.last4) + " ")]);
  })], 2)])])], _c("div", {
    staticClass: "saved-bank-info"
  }, [_vm._v(' *You can pay with your registered bank account by selecting the desired one. If no account is displayed, it is probably because you never selected the "save" option above when you made your very first ACH payment. ')])], 2) : _vm._e(), _vm.payment_method == "ba" ? _c("div", [_vm._v(" Select a bank account: "), _c("div", {
    staticClass: "formfield-select"
  }, [_c("div", {
    staticClass: "formfield-select--container"
  }, [_c("select", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.bankAccount,
      expression: "bankAccount"
    }],
    on: {
      change: [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.bankAccount = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.switchCard]
    }
  }, [_c("option", {
    domProps: {
      value: 0
    }
  }, [_vm._v("Add a new bank account")]), _vm._l(_vm.list_bank_accounts, function (ba) {
    return _c("option", {
      key: ba.payment_method_id,
      domProps: {
        value: ba
      }
    }, [_vm._v(" " + _vm._s(ba.country) + "XX" + _vm._s(ba.bank_name) + "XXXXXX" + _vm._s(ba.last4) + " ")]);
  })], 2)])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.bankAccount || _vm.bankAccount === 0,
      expression: "!!bankAccount || bankAccount === 0"
    }],
    staticClass: "divPaymentTypeDisplay"
  }, [_c("SepaBankAccount", {
    ref: "bankAccount",
    attrs: {
      order: _vm.order,
      clientSecret: _vm.client_secret,
      wallet: false,
      stripe: _vm.stripe,
      user: _vm.user
    },
    on: {
      confirm: _vm.confirmSepaBankAccount
    },
    model: {
      value: _vm.bankAccount,
      callback: function callback($$v) {
        _vm.bankAccount = $$v;
      },
      expression: "bankAccount"
    }
  })], 1), _c("div", {
    staticClass: "mandate-acceptance"
  }, [_vm._v(" By providing your payment information and confirming this payment, you authorise (A) " + _vm._s(_vm.$whitelabel.legalName) + " and Stripe, our payment service provider and/or PPRO, its local service provider, to send instructions to your bank to debit your account and (B) your bank to debit your account in accordance with those instructions. As part of your rights, you are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited. Your rights are explained in a statement that you can obtain from your bank. You agree to receive notifications for future debits up to 2 days before they occur. ")])]) : _vm._e()]), _c("div", {
    staticClass: "payment-debit-message"
  }, [_c("p", {
    staticClass: "tip"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2 text-yellow"
  }), _vm._v(" " + _vm._s(_vm.messagePaymentDate) + " ")])]), _c("WholesalersData", {
    attrs: {
      loggedUserData: _vm.loggedUserData,
      centered: true
    }
  }), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      disabled: !_vm.isAbleToPay,
      rounded: true,
      "data-cy": "confirm-payment-btn"
    },
    on: {
      click: function click($event) {
        return _vm.confirmPayment();
      }
    }
  }, [_vm._v(" Pay " + _vm._s(_vm.formatPrice(_vm.order.total_amount_currency_include_credit_notes)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])], 1)], 1)], 1) : _vm.orderValidated ? _c("div", [_c("div", {
    staticClass: "container-centered small-2"
  }, [_c("div", {
    staticClass: "payment-logo-img"
  }), _c("h2", [_vm._v("Order awaiting for validation")]), _vm._m(0), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.goHome();
      }
    }
  }, [_vm._v("Home")])], 1)])]) : _vm._e(), _c("PaymentGoBackDialog", {
    attrs: {
      shown: _vm.paymentGoBackDialogShown,
      title: _vm.paymentGoBackDialogTitle,
      text: _vm.paymentGoBackDialogText,
      routeName: "finalizeCart"
    }
  }), _c("PaymentMicroDepositsDialog", {
    attrs: {
      linkUrl: _vm.microDepositsUrl
    },
    on: {
      continue: _vm.continuePaymentFromDeposits
    },
    model: {
      value: _vm.paymentMicroDepositsShown,
      callback: function callback($$v) {
        _vm.paymentMicroDepositsShown = $$v;
      },
      expression: "paymentMicroDepositsShown"
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("p", [_vm._v(" Thank you for your order. "), _c("br"), _vm._v(" An e-mail has been sent to your email address with the order information. "), _c("br"), _vm._v(" If you do not see the email in a few minutes, check your “junk mail” folder or “spam” folder. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };